import createFold from './fold';

// "Show more" under each shortened text of Show More Cards; hidden when the whole text already shows.
function bind(item: HTMLElement): void {
	const text = item.querySelector<HTMLElement>('[data-armada-fold-text]');
	const button = item.querySelector<HTMLButtonElement>('[data-armada-fold-more]');
	const label = button?.querySelector('span');

	if (!text || !button || !label) {
		return;
	}

	const more = label.textContent ?? '';
	const less = button.dataset.less || more;
	const toggle = createFold(item, text, button);

	// Cards keep "Show more" level across a row, so the text gets as many whole lines as fit its box.
	const sync = (): void => {
		if (item.classList.contains('is-open')) {
			return;
		}

		const line = parseFloat(getComputedStyle(text).lineHeight);

		text.style.setProperty('--fold-lines', String(Math.max(1, Math.floor((text.clientHeight + 1) / line))));
		button.hidden = text.scrollHeight <= text.clientHeight + 2;
	};

	button.addEventListener('click', () => {
		const open = toggle();

		button.setAttribute('aria-expanded', String(open));
		label.textContent = open ? less : more;
	});

	sync();
	window.addEventListener('resize', sync, { passive: true });
}

// Comparison: the intro text is shortened on phones only; its button is plain text.
function bindCompare(root: HTMLElement): void {
	const text = root.querySelector<HTMLElement>('[data-armada-fold-text]');
	const button = root.querySelector<HTMLButtonElement>('[data-armada-fold-more]');

	if (!text || !button) {
		return;
	}

	const more = button.textContent ?? '';
	const less = button.dataset.less || more;
	const toggle = createFold(root, text, button);

	const sync = (): void => {
		if (!root.classList.contains('is-open')) {
			button.hidden = text.scrollHeight <= text.clientHeight + 2;
		}
	};

	button.addEventListener('click', () => {
		const open = toggle();

		button.setAttribute('aria-expanded', String(open));
		button.textContent = open ? less : more;
	});

	sync();
	window.addEventListener('resize', sync, { passive: true });
}

export default function initMoreCards(): void {
	document.querySelectorAll<HTMLElement>('.armada-more [data-armada-fold]').forEach(bind);
	document.querySelectorAll<HTMLElement>('[data-armada-compare-text]').forEach(bindCompare);
}
